'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  return name.toString().replace(/_PENDING|_REJECTED|_FULFILLED/, '');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/utils/get-action-name.js
// module id = 185
// module chunks = 0